module.exports = __webpack_public_path__ + "img/1.7688d637.jpg";